"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Content = exports.Sizes = exports.ContentWrapper = void 0;

var tslib_1 = require("tslib");

var ui_card_1 = require("@hopin-team/ui-card");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_helper_props_to_styles_1 = require("@hopin-team/ui-helper-props-to-styles");

var ui_symbols_1 = require("@hopin-team/ui-symbols");

var styled_components_1 = tslib_1.__importStar(require("styled-components"));

var isInverseStyles = (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  background: ", ";\n  color: ", ";\n"], ["\n  background: ", ";\n  color: ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)("COLOR.GREY[\"800\"]", theme);
}, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)("COLOR.GREY.WHITE", theme);
});
exports.ContentWrapper = styled_components_1.default.div(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  position: relative;\n  width: 100%;\n  height: 0;\n"], ["\n  position: relative;\n  width: 100%;\n  height: 0;\n"])));
var Sizes;

(function (Sizes) {
  Sizes[Sizes["small"] = 256] = "small";
  Sizes[Sizes["medium"] = 352] = "medium";
  Sizes[Sizes["large"] = 448] = "large";
})(Sizes = exports.Sizes || (exports.Sizes = {}));

var makeSizeStyles = function makeSizeStyles(size) {
  return (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  width: ", "rem;\n  @media (max-width: ", "rem) {\n    width: 100%;\n  }\n"], ["\n  width: ", "rem;\n  @media (max-width: ", "rem) {\n    width: 100%;\n  }\n"])), Sizes[size] / 16, Sizes[size] / 16);
};

var makeDoubleSizeStyles = function makeDoubleSizeStyles(size) {
  if (size) {
    return (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n      width: ", "rem;\n      @media (max-width: ", "rem) {\n        width: 100%;\n      }\n    "], ["\n      width: ", "rem;\n      @media (max-width: ", "rem) {\n        width: 100%;\n      }\n    "])), Sizes[size] / 16 * 2, Sizes[size] / 16 * 2);
  }

  return '';
};

var makePositionStyles = function makePositionStyles(isReverse) {
  return isReverse ? 'left: 0;' : 'right: 0;';
};

var hasTriggerElementStyles = (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["\n  width: 100%;\n  position: absolute;\n  margin-top: ", ";\n"], ["\n  width: 100%;\n  position: absolute;\n  margin-top: ", ";\n"])), (0, ui_symbols_1.calcSpace)(1));

var makeHeightStyles = function makeHeightStyles(visibleOptionsCount) {
  return (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = tslib_1.__makeTemplateObject(["\n  height: ", ";\n  overflow-y: scroll !important;\n"], ["\n  height: ", ";\n  overflow-y: scroll !important;\n"])), (0, ui_symbols_1.calcSpace)(visibleOptionsCount, 50, -16));
};

exports.Content = (0, styled_components_1.default)(ui_card_1.Card).attrs({
  cornerRadius: 'md'
})(templateObject_7 || (templateObject_7 = tslib_1.__makeTemplateObject(["\n  position: relative;\n  z-index: ", ";\n  padding: 0.5rem;\n\n  ", ";\n  ", "\n\n  ", "\n  ", "\n  ", "\n  ", "\n"], ["\n  position: relative;\n  z-index: ", ";\n  padding: 0.5rem;\n\n  ", ";\n  ", "\n\n  ", "\n  ", "\n  ", "\n  ", "\n"])), ui_symbols_1.PLANE.MENU, function (_a) {
  var hasTriggerElement = _a.hasTriggerElement;
  return hasTriggerElement && hasTriggerElementStyles;
}, function (_a) {
  var isReverse = _a.isReverse,
      hasTriggerElement = _a.hasTriggerElement;
  return hasTriggerElement && makePositionStyles(isReverse);
}, function (props) {
  return (0, ui_helper_props_to_styles_1.makeStyles)(props, 'size', makeSizeStyles);
}, function (props) {
  return props.isDouble && (0, ui_helper_props_to_styles_1.makeStyles)(props, 'size', makeDoubleSizeStyles);
}, function (props) {
  return (0, ui_helper_props_to_styles_1.switchStyles)(props, 'isInverse', isInverseStyles);
}, function (props) {
  return (0, ui_helper_props_to_styles_1.makeStyles)(props, 'visibleOptionsCount', makeHeightStyles);
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;